"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};

var Box = _styledComponents2.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 40rem;\n  margin: 0 auto;\n  background-color: white;\n  border-top: solid 1px #d1d1d1;\n  border-bottom: solid 1px #d1d1d1;\n  box-shadow: none;\n  border-radius: 0;\n\n  @media all and (min-width: 40rem) {\n    border-left: solid 1px #d1d1d1;\n    border-right: solid 1px #d1d1d1;\n  }\n"], ["\n  width: 100%;\n  max-width: 40rem;\n  margin: 0 auto;\n  background-color: white;\n  border-top: solid 1px #d1d1d1;\n  border-bottom: solid 1px #d1d1d1;\n  box-shadow: none;\n  border-radius: 0;\n\n  @media all and (min-width: 40rem) {\n    border-left: solid 1px #d1d1d1;\n    border-right: solid 1px #d1d1d1;\n  }\n"])));
exports.default = Box;

var templateObject_1;
//# sourceMappingURL=Box.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/Box/Box.js
// module id = 456
// module chunks = 0